import { getUserFacingApiMessage } from "./getUserFacingApiMessage";

/**
 * Extrai mensagem legível de erros lançados por fetchData (objeto ou Error).
 * Inclui o próximo passo (`userAction`) quando a API envia, para o toast não ficar só "Internal Server Error".
 */
export function getApiErrorMessage(err, fallback = "Ocorreu um erro.") {
  if (!err) return fallback;
  if (typeof err === "string") {
    const facing = getUserFacingApiMessage({ message: err });
    return facing.message && facing.message !== "Não foi possível concluir a operação."
      ? facing.message
      : fallback;
  }

  const facing = getUserFacingApiMessage(err);
  let message =
    facing.message && facing.message !== "Não foi possível concluir a operação."
      ? facing.message
      : fallback;
  if (!message) message = fallback;
  if (facing.action && !String(message).includes(facing.action)) {
    return `${message} ${facing.action}`.trim();
  }
  return message;
}
